'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { DefaultIcon } from '../../common';
import { StyledListItem, StyledIcon, StyledInnerListItem } from '../elements';
export const ListItemContext = /*#__PURE__*/React.createContext({});
export const ListItem = ({
  children,
  hasDivider,
  iconSrc,
  iconColor,
  ...rest
}) => {
  const {
    isCard,
    hasDividers,
    hasIcons,
    isSpacingCompact,
    isHorizontal
  } = React.useContext(ListItemContext);
  return /*#__PURE__*/React.createElement(StyledListItem, _extends({
    isCard: isCard,
    hasDivider: hasDivider,
    hasDividers: hasDividers,
    hasIcons: hasIcons,
    isSpacingCompact: isSpacingCompact,
    isHorizontal: isHorizontal
  }, rest), hasIcons && /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(DefaultIcon, {
    src: iconSrc,
    iconColor: iconColor
  })), /*#__PURE__*/React.createElement(StyledInnerListItem, null, children));
};